import CreateCustomerLightbox from './CreateCustomerLightbox'
import {loadPopupContentByRpcCall} from '../../../util/PopupLoadingUtils'
import {arrayToSet} from '../../../atUtils'
import {hasSomeTeamAssignment} from '../../../util/accessRightsUtils'

export default class CreateCustomerPopupController {

    constructor({
        createCustomerStartCb,
        createCustomerSuccessCb,
        createCustomerFailureCb,
        copyTasksCb,
    }) {
        this.callbacks = {
            createCustomerStartCb,
            createCustomerSuccessCb,
            createCustomerFailureCb,
            copyTasksCb,
        }
    }

    showPopup() {
        this._requestPopupData(
            (contentData) => {
                new CreateCustomerLightbox(
                    contentData,
                    {
                        successHandler: this.callbacks.createCustomerSuccessCb,
                        copyTasksCb: this.callbacks.copyTasksCb,
                        createCustomerStartCb: this.callbacks.createCustomerStartCb,
                        createCustomerFailureCb: this.callbacks.createCustomerFailureCb,
                    }
                ).init().show()
            }
        )
    }

    _requestPopupData(onSuccessCb, onErrorCb) {
        loadPopupContentByRpcCall("CustomerInfoService.getCreateCustomerPopupData", [],
            (data) => {
                onSuccessCb({
                    customerInfos: data['customers'],
                    enabledFeatures: arrayToSet(data['enabledFeatures']),
                    assignedUsersData: data['assignedUsersData'],
                    assignedUsersDataForManagers: data['assignedUsersDataForManagers'],
                    canManageAccountsAndPermissions: data['canManageAccountsAndPermissions'],
                    hasSomeTeamAssignment: data['hasSomeTeamAssignment']
                })
            },
            true,
            onErrorCb,
            true)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/customer/CreateCustomerPopupController.js